
import { get, post } from './http'

const base = '/operating-platform/campaign/frontend/gallery'
const gallery = {
  // 分页查询作品页标记图片信息
  getPicList: (params) => {
    return get(`${base}/featured/list`, params)
  },
  // 分页查询作品页用户排行信息
  getRankList: (params) => {
    return get(`${base}/ranking/list`, params)
  },
  // 通过活动名称查询作品页活动详情
  getGalleryList: (params) => {
    return get(`${base}/getByName`, params)
  },
  // 查询作品关联菜单
  getAssociationList: (params) => {
    return get(`${base}/association/list`)
  },
  // 获取分类下的gallery
  getGalleryCategoryList: () => {
    return get(`${base}/category/list`)
  },
}
export default gallery


